import { useEffect } from 'react';

const useEscapeKeyClose = (isOpen: boolean, onClose: () => void): void => {
  useEffect(() => {
    if (!isOpen || typeof document === 'undefined') {
      return;
    }

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);
};

export default useEscapeKeyClose;
